// src/client/super/EventList.tsx
import { useEffect, useState } from "react";
import { api, type EventRow } from "../lib/api";
import { isNowBetween } from "../lib/dates";
import { useNavigate } from "react-router-dom";
import HomeButton from "../components/HomeButton";

export default function EventsList() {
  const [rows, setRows] = useState<EventRow[]>([]);
  const [loading, setLoading] = useState(true);
  const nav = useNavigate();

  useEffect(() => {
    let alive = true;
    (async () => {
      try {
        setLoading(true);
        const list = await api.events.list();
        if (!alive) return;
        setRows(list);
      } finally {
        if (alive) setLoading(false);
      }
    })();
    return () => { alive = false; };
  }, []);

  if (loading) return <div className="text-neutral-300">Загрузка…</div>;
  if (!rows.length) {
    return (
      <div className="grid gap-4">
        <div className="flex justify-between">
          <HomeButton />
          <button
            onClick={() => nav("/super/events/new")}
            className="rounded-2xl border border-white/15 bg-white/10 px-4 py-2 text-white hover:bg-white/15"
          >
            Создать
          </button>
        </div>
        <div className="text-neutral-300">Мероприятий пока нет.</div>
      </div>
    );
  }

  const current = rows.filter(r => isNowBetween(r.starts_at, r.ends_at));
  const past    = rows.filter(r => r.ends_at && +new Date(r.ends_at) < Date.now());

  return (
    <div className="grid gap-6">
      <div className="mb-4 flex items-center justify-between">
        <HomeButton />
        <button
          onClick={() => nav("/super/events/new")}
          className="rounded-2xl border border-white/15 bg-white/10 px-4 py-2 text-white hover:bg-white/15"
        >
          Создать
        </button>
      </div>

      {!!current.length && (
        <section>
          <h3 className="mb-3 text-lg font-semibold">Текущее</h3>
          <div className="grid gap-3">
            {current.map(e => (
              <EventCard key={e.id} e={e} onEdit={() => nav(`/super/events/${e.id}/edit`)} />
            ))}
          </div>
        </section>
      )}

      <section>
        <h3 className="mb-3 text-lg font-semibold">Прошедшие</h3>
        <div className="grid gap-3">
          {past.map(e => (
            <EventCard key={e.id} e={e} />
          ))}
        </div>
      </section>
    </div>
  );
}

function EventCard({ e, onEdit }: { e: EventRow; onEdit?: () => void }) {
  return (
    <div className="ui-panel">
      <div className="flex items-center justify-between gap-3">
        <div className="min-w-0">
          <div className="truncate text-[16px] font-semibold">{e.title}</div>
          <div className="text-xs text-neutral-400">
            {e.starts_at ? new Date(e.starts_at).toLocaleString() : "—"} → {e.ends_at ? new Date(e.ends_at).toLocaleString() : "—"}
          </div>
        </div>
        {onEdit && (
          <button
            onClick={onEdit}
            className="ui-btn-sm shrink-0 text-xs"
          >
            Редактировать
          </button>
        )}
      </div>

      <div className="mt-3 grid grid-cols-2 gap-3 text-xs">
        <Stat label="QR TTL" value={`${e.qr_valid_for_minutes ?? "—"} мин`} />
        <Stat label="Статус" value={e.status} />
      </div>
    </div>
  );
}

function Stat({ label, value }: { label: string; value: string | number }) {
  return (
    <div className="ui-panel p-3 text-center">
      <div className="text-neutral-400">{label}</div>
      <div className="mt-1 font-medium">{value}</div>
    </div>
  );
}
function fmtMoney(v: number | null) {
  if (v == null) return "—";
  return new Intl.NumberFormat("ru-RU").format(v) + " ₽";
}
